$(document).ready(function () {
  function initSlick() {
    // 画像スライダー（メイン）
    $(".js-kv-slider-images").slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      asNavFor: ".js-kv-slider-cards",
      centerMode: true,
      variableWidth: true,
      speed: 1000,
    });

    // テキストカードスライダー（ナビゲーション）
    $(".js-kv-slider-cards").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".js-kv-slider-images",
      dots: true,
      appendArrows: ".js-kv-slider__cards-navInner",
      appendDots: ".js-kv-slider__cards-navInner",
      speed: 1000,
    });

    $('.js-category-slider').slick({
      rows: 3,
      dots: true,
      arrows: true,
      infinite: false,
      appendDots: '.js-category-slider-nav',
      appendArrows: '.js-category-slider-arrows',
    });

    $('.js-recipe-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: '.js-recipe-slider-nav',
      appendArrows: '.js-recipe-slider-arrows',
      infinite: false,
    });

    $('.js-movie-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      appendDots: '.js-movie-slider-nav',
      appendArrows: '.js-movie-slider-arrows',
      infinite: false,
      responsive: [{
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
        }
      }]
    });
  }


  function initSpSlick() {
    if (window.matchMedia("(max-width: 989px)").matches) {
      if (!$('.js-sp-slider').hasClass('slick-initialized')) {
        $('.js-sp-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          variableWidth: true,
          appendArrows: '.js-sp-slider__nav',
          infinite: false,
        });

        $('.js-sp-slider2').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          variableWidth: true,
          appendArrows: '.js-sp-slider2__nav',
          infinite: false,
        });

        $('.js-sp-slider3').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          variableWidth: true,
          appendArrows: '.js-sp-slider3__nav',
          infinite: false,
        });
      }
    } else {
      if ($('.js-sp-slider').hasClass('slick-initialized')) {
        $('.js-sp-slider').slick('unslick');
      }
      if ($('.js-sp-slider2').hasClass('slick-initialized')) {
        $('.js-sp-slider2').slick('unslick');
      }
    }
  }

  // 初回実行
  initSlick();
  initSpSlick();

  // リサイズ時に判定
  $(window).on('resize', function () {
    initSpSlick();
  });
});